document.addEventListener('DOMContentLoaded', function () {
	initLimparAtributoPix()
	initHeaderMenu()
	initAppLinks()
	initCouponBar()
	initMinicart()
	initShelfAddToCart()
	initNewsletterForm()
	initCookieConsent()
	initHomeFloatBar()
	initAccordions()
	initScrollSnapNav()
	initModals()
	initStoreStars()
	initKonfidencyProductRatings()
})

document.addEventListener('shopify:section:load', function () {
	initStoreStars()
	initKonfidencyProductRatings()
})

/* ==========================================================================
   Konfidency reviews (store summary and product ratings, cached by URL)
   ========================================================================== */
var KONFIDENCY_API_FALLBACK = 'https://reviews-api.konfidency.com.br/sterilair'
var konfidencyRequestCache = {}

function getKonfidencyApiBase() {
	var configuredUrl = window.themeSettings && window.themeSettings.reviewsApiUrl
	var apiUrl = String(configuredUrl || KONFIDENCY_API_FALLBACK).replace(/\/$/, '')
	return apiUrl.replace(/\/all-reviews(?:\?.*)?$/, '')
}

function fetchKonfidency(path) {
	var url = getKonfidencyApiBase() + path
	if (konfidencyRequestCache[url]) return konfidencyRequestCache[url]

	konfidencyRequestCache[url] = fetch(url)
		.then(function (response) {
			if (!response.ok) throw new Error('Falha ao buscar avaliações na Konfidency')
			return response.json()
		})
		.catch(function (error) {
			delete konfidencyRequestCache[url]
			throw error
		})

	return konfidencyRequestCache[url]
}

function fetchStoreStars() {
	return fetchKonfidency('/all-reviews?pageSize=1')
}

function initStoreStars() {
	var widgets = document.querySelectorAll('[data-store-stars]')
	if (!widgets.length) return

	fetchStoreStars().then(function (data) {
		var summary = data && data.reviews && data.reviews.summary
		var count = summary && Number(summary.reviewCount || 0)
		if (!count) return

		widgets.forEach(function (widget) {
			var countEl = widget.querySelector('[data-store-stars-count]')
			if (countEl) countEl.textContent = count.toLocaleString('pt-BR')
			widget.classList.remove('is-loading')
		})

		document.querySelectorAll('[data-store-recommended-heading]').forEach(function (heading) {
			var percentage = Math.round(Number(summary.recommendedPercentage || 0))
			heading.textContent = heading.textContent.replace(/^\s*\d+%/, percentage + '%')
		})
	}).catch(function (error) {
		console.error(error)
	})
}

function initKonfidencyProductRatings() {
	document.querySelectorAll('[data-konfidency-product-rating]').forEach(function (widget) {
		if (widget.dataset.konfidencyReady === 'true') return

		var sku = widget.dataset.konfidencySku
		if (!sku) return
		widget.dataset.konfidencyReady = 'true'

		fetchKonfidency('/ratings?skus=' + encodeURIComponent(sku))
			.then(function (ratings) {
				var rating = Array.isArray(ratings) && ratings[0]
				if (!rating) return

				widget.querySelectorAll('[data-konfidency-product-count]').forEach(function (element) {
					element.textContent = Number(rating.reviewCount || 0).toLocaleString('pt-BR')
				})
				widget.querySelectorAll('[data-konfidency-product-score]').forEach(function (element) {
					element.textContent = Number(rating.aggregateRating || 0).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
				})
				widget.classList.remove('is-loading')
				widget.querySelectorAll('.is-loading').forEach(function (element) { element.classList.remove('is-loading') })
			})
			.catch(function () {
				widget.setAttribute('data-konfidency-error', 'true')
			})
	})
}

/* ==========================================================================
   Generic modal (e.g. home 2nd-unit promotion)
   ========================================================================== */
function initModals() {
	document.querySelectorAll('[data-modal]').forEach(function (modal) {
		var triggerId = modal.id + '-trigger'
		var trigger = document.getElementById(triggerId)
		var closeBtn = modal.querySelector('[data-modal-close]')
		var content = modal.querySelector('[data-modal-content]')

		function open() {
			modal.classList.remove('hidden')
			modal.classList.add('grid')
			document.body.style.overflow = 'hidden'
		}

		function close() {
			modal.classList.add('hidden')
			modal.classList.remove('grid')
			document.body.style.overflow = ''
		}

		if (trigger) trigger.addEventListener('click', open)
		if (closeBtn) closeBtn.addEventListener('click', close)
		modal.addEventListener('click', close)
		if (content) content.addEventListener('click', function (event) { event.stopPropagation() })
	})
}

/* ==========================================================================
   Header: mobile menu toggle
   ========================================================================== */
function initHeaderMenu() {
	var toggle = document.getElementById('site-header-menu-toggle')
	var nav = document.getElementById('site-header-nav')
	if (!toggle || !nav) return

	toggle.addEventListener('click', function () {
		var isOpen = nav.getAttribute('data-open') === 'true'
		nav.setAttribute('data-open', String(!isOpen))
		toggle.setAttribute('aria-expanded', String(!isOpen))
	})
}

/* ==========================================================================
   Links que abrem app no celular (Mercado Livre). Em aba nova, o sistema
   entrega o endereço ao app e a aba fica vazia; ao voltar do app, a pessoa
   cai nessa aba em branco. Em tela de toque o link abre na mesma aba: o app
   abre e o site continua onde estava. No computador segue em aba nova.
   ========================================================================== */
/**
 * O checkout grava no carrinho o atributo que liga a Function de desconto do
 * PIX (lá o PIX já vem pré-selecionado). Se o cliente volta para o site com o
 * atributo gravado, a Shopify aplica o desconto do PIX no próprio carrinho e
 * o total "no cartão" passa a ser o total do PIX (872,50 nos dois, em vez de
 * 918,43 e 872,50). Fora do checkout o atributo não tem função: é removido e
 * os preços recarregam. Ao voltar ao checkout, a extensão grava de novo
 * conforme a forma de pagamento escolhida.
 */
function initLimparAtributoPix() {
	if (!document.body.hasAttribute('data-limpar-atributo-pix')) return
	var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'

	fetch(root + 'cart/update.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
		body: JSON.stringify({
			attributes: { _sterilair_pagamento_avista: null },
			sections: 'minicart',
			sections_url: window.location.pathname
		})
	})
		.then(function (response) { return response.json() })
		.then(function (data) {
			var atributos = data.attributes || {}
			// Só recarrega se o atributo saiu mesmo; senão a página entraria em loop.
			if (atributos._sterilair_pagamento_avista) return
			document.body.removeAttribute('data-limpar-atributo-pix')

			if (document.querySelector('[data-cart-page]')) {
				window.location.reload()
				return
			}

			var sectionHtml = data.sections && data.sections.minicart
			if (!sectionHtml) return
			var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html')
			var updatedMinicart = parsed.getElementById('minicart')
			var currentMinicart = document.getElementById('minicart')
			if (updatedMinicart && currentMinicart) currentMinicart.innerHTML = updatedMinicart.innerHTML
		})
		.catch(function () {})
}

function initAppLinks() {
	var touch = window.matchMedia('(pointer: coarse)').matches
	if (!touch) return
	document.querySelectorAll('a[data-app-link]').forEach(function (link) {
		link.removeAttribute('target')
	})
}

/* ==========================================================================
   Header: coupon bar click-to-apply
   ========================================================================== */
function initCouponBar() {
	var bar = document.getElementById('header-coupon-bar')
	if (!bar) return

	function copyCoupon(code) {
		if (navigator.clipboard) {
			navigator.clipboard.writeText(code).catch(function () {})
		}
	}

	function applyCoupon() {
		var code = bar.getAttribute('data-coupon-code')
		if (!code) return

		if (bar.getAttribute('data-applied') === 'true') {
			showToast('Cupom "' + code + '" já está adicionado ao seu carrinho.', 'info')
			copyCoupon(code)
			return
		}

		bar.setAttribute('aria-busy', 'true')

		fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ discount: code })
		})
			.then(function (response) {
				if (!response.ok) throw new Error('Discount request failed')
				return response.json()
			})
			.then(function () {
				bar.setAttribute('data-applied', 'true')
				showToast('Cupom "' + code + '" foi adicionado ao seu carrinho.', 'success')
				copyCoupon(code)
			})
			.catch(function () {
				showToast('Não foi possível aplicar o cupom. Tente novamente.', 'error')
			})
			.finally(function () {
				bar.removeAttribute('aria-busy')
			})
	}

	bar.addEventListener('click', applyCoupon)
	bar.addEventListener('keydown', function (event) {
		if (event.key !== 'Enter' && event.key !== ' ') return
		event.preventDefault()
		applyCoupon()
	})
}


function createToastIcon(type) {
	var icon = document.createElement('span')
	icon.className = 'theme-toast__icon'
	icon.setAttribute('aria-hidden', 'true')

	if (type === 'success') {
		icon.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="12"></circle><path d="m7 12.5 3.2 3.2L17.5 8" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
	} else if (type === 'error') {
		icon.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="12"></circle><path d="m8 8 8 8m0-8-8 8" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"></path></svg>'
	} else {
		icon.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="12"></circle><path d="M12 10v7m0-10v.01" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"></path></svg>'
	}

	return icon
}

function showToast(message, type) {
	var currentContainer = document.querySelector('.theme-toast-container')
	if (currentContainer) currentContainer.remove()

	var container = document.createElement('div')
	container.className = 'theme-toast-container'

	var toast = document.createElement('div')
	toast.className = 'theme-toast theme-toast--' + type
	toast.setAttribute('role', 'alert')
	toast.setAttribute('aria-live', 'polite')

	var body = document.createElement('div')
	body.className = 'theme-toast__body'
	body.appendChild(createToastIcon(type))

	var text = document.createElement('div')
	text.textContent = message
	body.appendChild(text)

	var close = document.createElement('button')
	close.type = 'button'
	close.className = 'theme-toast__close'
	close.setAttribute('aria-label', 'Fechar notificação')
	close.textContent = '×'

	var progress = document.createElement('div')
	progress.className = 'theme-toast__progress'
	progress.setAttribute('aria-hidden', 'true')

	toast.appendChild(body)
	toast.appendChild(close)
	toast.appendChild(progress)
	container.appendChild(toast)
	document.body.appendChild(container)

	var removeToast = function () {
		toast.classList.remove('theme-toast--visible')
		setTimeout(function () { container.remove() }, 300)
	}

	close.addEventListener('click', removeToast)
	requestAnimationFrame(function () {
		toast.classList.add('theme-toast--visible')
	})
	setTimeout(removeToast, 3000)
}

/* ==========================================================================
   Limite de unidades por pedido
   ========================================================================== */
/**
 * Config gravada pelo painel do app em sterilair.limite_unidades_config e
 * impressa no minicarrinho por snippets/minicart.liquid. Espelha a Function
 * cart-validations-generate-run (sterilair-app, extensions/limite-unidades):
 * aqui é só UX, quem garante de verdade que ninguém passa do limite é ela.
 *
 * Devolve `null` quando não há limite a aplicar — sem config, sem produtos na
 * lista ou sem número. Nunca tratar ausência como limite zero: zero barraria
 * qualquer quantidade.
 */
function lerLimiteConfig() {
	var minicart = document.getElementById('minicart')
	if (!minicart || !minicart.dataset.limitConfig) return null

	try {
		var config = JSON.parse(minicart.dataset.limitConfig)
		if (!config || !config.produtos || !config.produtos.length || !config.limite) return null
		return {
			limite: config.limite,
			mensagem: config.mensagem,
			// O carrinho expõe o id numérico do produto; a config guarda o GID.
			produtos: config.produtos.map(function (gid) { return String(gid).replace(/\D/g, '') })
		}
	} catch (error) {
		return null
	}
}

/** Unidades dos produtos com limite já no carrinho, exceto a linha informada. */
function totalLimitadoNoMinicart(config, itemIgnorado) {
	var minicart = document.getElementById('minicart')
	if (!minicart || !config) return 0

	var total = 0
	minicart.querySelectorAll('.minicart__item').forEach(function (item) {
		if (item === itemIgnorado) return
		if (config.produtos.indexOf(item.dataset.productId) === -1) return
		var input = item.querySelector('[data-qty-input]')
		// Sem teto aqui: contar menos do que o carrinho tem deixaria passar.
		total += Math.max(parseInt(input && input.value ? input.value : '1', 10) || 1, 1)
	})
	return total
}

/* ==========================================================================
   Minicart drawer + Cart AJAX API
   ========================================================================== */
function initMinicart() {
	var cartToggle = document.getElementById('site-header-cart-toggle')
	var minicart = document.getElementById('minicart')
	var backdrop = document.getElementById('minicart-backdrop')
	if (!minicart) return

	function openCart() {
		minicart.setAttribute('data-open', 'true')
		if (backdrop) backdrop.setAttribute('data-open', 'true')
		document.body.style.overflow = 'hidden'
	}

	function closeCart() {
		minicart.setAttribute('data-open', 'false')
		if (backdrop) backdrop.setAttribute('data-open', 'false')
		document.body.style.overflow = ''
	}

	var limitConfig = lerLimiteConfig()

	/** Teto desta linha, como o snippets/minicart.liquid renderizou no campo. */
	function maxDaLinha(input) {
		var max = parseInt(input && input.getAttribute('max'), 10)
		return max > 0 ? max : 10
	}

	function getItemQuantity(item) {
		var input = item && item.querySelector('[data-qty-input]')
		return Math.min(Math.max(parseInt(input && input.value ? input.value : '1', 10), 1), maxDaLinha(input))
	}

	/** Quantidade que o servidor renderizou, antes de o cliente digitar por cima. */
	function quantidadeOriginal(item) {
		var input = item && item.querySelector('[data-qty-input]')
		return Math.max(parseInt(input && input.defaultValue ? input.defaultValue : '1', 10) || 1, 1)
	}

	/**
	 * Só barra aumento. Se o carrinho já passou do limite — o lojista pode
	 * tê-lo baixado depois —, reduzir precisa continuar valendo, senão o
	 * cliente fica sem saída a não ser remover a linha inteira.
	 */
	function excedeLimite(itemAlterado, novaQuantidade) {
		if (!limitConfig) return false
		if (limitConfig.produtos.indexOf(itemAlterado.dataset.productId) === -1) return false
		if (novaQuantidade <= quantidadeOriginal(itemAlterado)) return false
		return totalLimitadoNoMinicart(limitConfig, itemAlterado) + novaQuantidade > limitConfig.limite
	}

	if (cartToggle) cartToggle.addEventListener('click', openCart)
	if (backdrop) backdrop.addEventListener('click', closeCart)

	minicart.addEventListener('click', function (event) {
		var closeBtn = event.target.closest('#minicart-close')
		var decreaseBtn = event.target.closest('[data-qty-decrease]')
		var increaseBtn = event.target.closest('[data-qty-increase]')
		var removeBtn = event.target.closest('[data-remove-item]')

		if (closeBtn) {
			closeCart()
			return
		}

		if (decreaseBtn || increaseBtn) {
			var item = event.target.closest('.minicart__item')
			var current = getItemQuantity(item)
			var next = Math.min(Math.max(current + (increaseBtn ? 1 : -1), 1), maxDaLinha(item.querySelector('[data-qty-input]')))
			if (next !== current && increaseBtn && excedeLimite(item, next)) {
				showToast(limitConfig.mensagem || 'Limite de unidades por pedido atingido.', 'error')
				return
			}
			if (next !== current) updateCartLine(item.getAttribute('data-line'), next)
		}

		if (removeBtn) {
			var removeItemEl = event.target.closest('.minicart__item')
			var removeQuantity = getItemQuantity(removeItemEl)
			updateCartLine(removeItemEl.getAttribute('data-line'), Math.max(removeQuantity - 1, 0))
		}
	})

	minicart.addEventListener('change', function (event) {
		if (!event.target.matches('[data-qty-input]')) return
		var item = event.target.closest('.minicart__item')
		var qty = Math.min(Math.max(parseInt(event.target.value || '1', 10), 1), maxDaLinha(event.target))
		if (excedeLimite(item, qty)) {
			showToast(limitConfig.mensagem || 'Limite de unidades por pedido atingido.', 'error')
			// defaultValue, não o campo: o cliente já digitou por cima do valor.
			event.target.value = quantidadeOriginal(item)
			return
		}
		event.target.value = qty
		updateCartLine(item.getAttribute('data-line'), qty)
	})

	minicart.addEventListener('keydown', function (event) {
		if (event.key !== 'Enter' || !event.target.matches('[data-qty-input]')) return
		event.preventDefault()
		event.target.blur()
	})

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape' && minicart.getAttribute('data-open') === 'true') closeCart()
	})
}

function initShelfAddToCart() {
	var forms = document.querySelectorAll('.home-shelf-add-form')
	if (!forms.length) return

	forms.forEach(function (form) {
		form.addEventListener('submit', function (event) {
			event.preventDefault()

			var button = form.querySelector('[type="submit"]')
			var originalLabel = button ? button.textContent : ''
			var formData = new FormData(form)
			var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'

			// Este mesmo handler atende as vitrines e os botões de compra das
			// páginas de produto, que somam uma linha nova em vez de mexer na
			// quantidade de uma existente: sem esta checagem, o limite só
			// aparecia depois, no carrinho.
			var limitConfig = lerLimiteConfig()
			var produtoId = form.dataset.productId
			if (limitConfig && produtoId && limitConfig.produtos.indexOf(produtoId) !== -1) {
				var adicionando = Math.max(parseInt(formData.get('quantity') || '1', 10) || 1, 1)
				if (totalLimitadoNoMinicart(limitConfig, null) + adicionando > limitConfig.limite) {
					showToast(limitConfig.mensagem || 'Limite de unidades por pedido atingido.', 'error')
					return
				}
			}

			formData.append('sections', 'minicart')
			formData.append('sections_url', window.location.pathname)

			if (button) {
				button.disabled = true
				button.textContent = 'Adicionando...'
			}

			fetch(root + 'cart/add.js', {
				method: 'POST',
				headers: { 'Accept': 'application/json' },
				body: formData
			})
				.then(function (response) {
					return response.json().then(function (data) {
						if (!response.ok) throw new Error(data.description || 'Não foi possível adicionar o produto.')
						return data
					})
				})
				.then(function (data) {
					var sectionHtml = data.sections && data.sections.minicart
					if (!sectionHtml || !renderMinicartSection(sectionHtml)) {
						window.location.assign(root + 'cart')
						return
					}

					showToast('Produto adicionado ao carrinho.', 'success')
				})
				.catch(function (error) {
					showToast(error.message || 'Não foi possível adicionar o produto.', 'error')
				})
				.finally(function () {
					if (button) {
						button.disabled = false
						button.textContent = originalLabel
					}
				})
		})
	})
}

function renderMinicartSection(sectionHtml) {
	var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html')
	var updatedMinicart = parsed.getElementById('minicart')
	var currentMinicart = document.getElementById('minicart')
	var backdrop = document.getElementById('minicart-backdrop')
	if (!updatedMinicart || !currentMinicart) return false

	currentMinicart.innerHTML = updatedMinicart.innerHTML
	currentMinicart.setAttribute('data-open', 'true')
	if (backdrop) backdrop.setAttribute('data-open', 'true')
	document.body.style.overflow = 'hidden'

	var updatedCount = updatedMinicart.querySelector('#minicart-count')
	var headerCount = document.getElementById('site-header-cart-count')
	if (updatedCount && headerCount) headerCount.textContent = updatedCount.textContent

	return true
}

function updateCartLine(line, quantity) {
	var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'
	setMinicartLoading(true)

	fetch(root + 'cart/change.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
		body: JSON.stringify({
			line: line,
			quantity: quantity,
			sections: 'minicart',
			sections_url: window.location.pathname
		})
	})
		.then(function (response) {
			return response.json().then(function (data) {
				if (!response.ok) throw new Error(data.description || 'Não foi possível atualizar o carrinho.')
				return data
			})
		})
		.then(function (data) {
			var sectionHtml = data.sections && data.sections.minicart
			if (!sectionHtml || !renderMinicartSection(sectionHtml)) window.location.assign(root + 'cart')
		})
		.catch(function (error) {
			showToast(error.message || 'Não foi possível atualizar o carrinho.', 'error')
		})
		.finally(function () { setMinicartLoading(false) })
}

function setMinicartLoading(active) {
	var loading = document.getElementById('minicart-loading')
	if (loading) loading.setAttribute('data-active', String(active))
}

/* ==========================================================================
   Newsletter form
   ========================================================================== */
function initNewsletterForm() {
	var forms = document.querySelectorAll('[data-newsletter-form]')

	forms.forEach(function (form) {
		var nameInput = form.querySelector('#newsletter-name')
		var mailInput = form.querySelector('#newsletter-mail')
		var submitBtn = form.querySelector('[data-newsletter-submit]')

		function refreshState() {
			var ready = nameInput.value.trim() && mailInput.value.trim()
			submitBtn.disabled = !ready
			submitBtn.textContent = ready ? 'Cadastrar' : 'Digite o nome e e-mail'
		}

		nameInput.addEventListener('input', refreshState)
		mailInput.addEventListener('input', refreshState)
	})
}

/* ==========================================================================
   Cookie consent (Shopify Customer Privacy API + local persistence)
   ========================================================================== */
function initCookieConsent() {
  var banner = document.getElementById('cookie-consent')
  var acceptBtn = document.getElementById('cookie-consent-accept')
  if (!banner) return

  var STORAGE_KEY = 'cookie-accept'

  function hasLocalConsent() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY)
      if (!raw) return false
      var parsed = JSON.parse(raw)
      return parsed.expires > Date.now()
    } catch (error) {
      return false
    }
  }

  function hasShopifyConsent() {
    try {
      var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy
      if (!customerPrivacy || typeof customerPrivacy.currentVisitorConsent !== 'function') return false

      var consent = customerPrivacy.currentVisitorConsent()
      return consent.analytics === 'yes' && consent.marketing === 'yes' && consent.preferences === 'yes'
    } catch (error) {
      return false
    }
  }

  function persistLocalConsent() {
    try {
      var expires = Date.now() + 30 * 24 * 60 * 60 * 1000
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ expires: expires }))
    } catch (error) {
      // The banner must still close when storage is blocked by the browser.
    }
  }

  function dispatchAcceptedEvent() {
    window.dispatchEvent(new Event('cookie-consent-accepted'))
  }

  function registerShopifyConsent() {
    try {
      var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy
      if (!customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') {
        dispatchAcceptedEvent()
        return
      }

      customerPrivacy.setTrackingConsent(
        {
          analytics: true,
          marketing: true,
          preferences: true
        },
        dispatchAcceptedEvent
      )
    } catch (error) {
      dispatchAcceptedEvent()
    }
  }

  function accept() {
    banner.hidden = true
    persistLocalConsent()
    registerShopifyConsent()
  }

  if (hasLocalConsent() || hasShopifyConsent()) return

  banner.hidden = false

  if (acceptBtn) {
    acceptBtn.addEventListener('click', function () {
      accept()
    })
  }
}

/* ==========================================================================
   Home: sticky float bar after scrolling past the hero
   ========================================================================== */
function initHomeFloatBar() {
	var fold = document.getElementById('home-fold')
	var floatBar = document.getElementById('home-float-bar')
	if (!fold || !floatBar) return

	if ('IntersectionObserver' in window) {
		var observer = new IntersectionObserver(
			function (entries) {
				var entry = entries[0]
				floatBar.setAttribute('data-visible', String(entry.boundingClientRect.bottom <= 0))
			},
			{ threshold: 0 }
		)
		observer.observe(fold)
	} else {
		window.addEventListener('scroll', function () {
			floatBar.setAttribute('data-visible', String(window.scrollY >= fold.offsetHeight))
		}, { passive: true })
	}
}

/* ==========================================================================
   Generic accordion (FAQ)
   ========================================================================== */
function initAccordions() {
	document.querySelectorAll('[data-accordion-item]').forEach(function (item) {
		item.addEventListener('click', function () {
			var isOpen = item.getAttribute('data-open') === 'true'
			item.setAttribute('data-open', String(!isOpen))
		})
	})
}

/* ==========================================================================
   Scroll-spy for the sticky home sub-navigation
   ========================================================================== */
function initScrollSnapNav() {
	var links = document.querySelectorAll('[data-scrollspy-link]')
	if (!links.length) return

	var targets = Array.prototype.map.call(links, function (link) {
		var id = link.getAttribute('href').replace('#', '')
		return document.getElementById(id)
	}).filter(Boolean)

	if (!('IntersectionObserver' in window) || !targets.length) return

	var observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				var link = document.querySelector('[data-scrollspy-link][href="#' + entry.target.id + '"]')
				if (!link) return
				link.classList.toggle('is-active', entry.isIntersecting)
			})
		},
		{ rootMargin: '-40% 0px -40% 0px' }
	)

	targets.forEach(function (target) { observer.observe(target) })
}
